export interface ImageProps {
  link: string;
  description: string;
}

export const imageList: ImageProps[] = [
  {
    link: "https://images.pexels.com/photos/3318214/pexels-photo-3318214.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    description: "Três gatos sendo alimentados",
  },
  {
    link: "https://plus.unsplash.com/premium_photo-1663099712421-266237bee59b?q=80&w=1826&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Marmita sendo entregue",
  },
  {
    link: "https://images.unsplash.com/photo-1628717341663-0007b0ee2597?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Mulher e menina separando itens em sacolas",
  },
  {
    link: "https://images.unsplash.com/photo-1529390079861-591de354faf5?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Criança estudando",
  },
  {
    link: "https://images.pexels.com/photos/2304253/pexels-photo-2304253.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    description: "Mão segurando uma folha de árvore",
  },
  {
    link: "https://ogimg.infoglobo.com.br/in/25135824-539-534/FT1086A/94014998_RI-Rio-de-Janeiro-RJ-23-07-2021FAZER-O-BEM-SEM-OLHAR-A-QUEMGrupo-de-amigos-se-ju.jpg",
    description: "Pessoas ajudando moradores de rua",
  },
  {
    link: "https://images.pexels.com/photos/6995247/pexels-photo-6995247.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    description: "Marmitas sendo montadas",
  },
  {
    link: "https://images.pexels.com/photos/18429371/pexels-photo-18429371/free-photo-of-mulheres-sentado-grupo-turma.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    description: "Mulher cuidando de idosa em cadeira de rodas",
  },
];
